// Google Analytics 4 helpers

export const trackEvent = (name: string, params?: Record<string, string>) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

export const trackClick = (category: string, label: string) => {
  trackEvent("click", { event_category: category, event_label: label });
};

export const trackPageView = (path: string) => {
  if (typeof window.gtag === "function") {
    window.gtag("config", window.__GA_ID__ ?? "", { page_path: path });
  }
};
